<template>
    <div class="no-auth-modal">
        <el-alert title="无该项目权限，请联系上级进行账户授权，赋予权限后可使用该项目" type="error" :closable=false>
        </el-alert>
        <!-- <h5 style="padding: 12px 0 8px 0px">可赋予权限得账户列表</h5> -->
        <div style="max-height: 50vh;overflow-y: auto;">
            <h5 style="padding: 12px 0 8px 0px" >可赋予权限的账户列表:</h5>
            <div v-for="(item, index) in list" :key="index" class="ml20">
                <h5 style="padding-bottom: 8px;">{{item.app_name}}</h5>
                <ul >
                    <li v-for="(ele, i) in item.error_msg" :key="i">{{ele}}</li>
                </ul>
            </div>
        </div>
        <p class="dialog-footer tac mt20">
            <el-button type="default" @click="$emit('close')" class="action-btn ml10 mr10">关闭</el-button>
        </p>
    </div>
</template>

<script>
export default {
    props:[ 'list' ]
}
</script>

<style lang="scss" scoped>
.no-auth-modal {
    li {
        padding: 6px 0;
        font-size: 12px;
    }
}

</style>